import React, { Component } from 'react';
import styled from 'styled-components';
import AliceCarousel from 'react-alice-carousel'
import 'react-alice-carousel/lib/alice-carousel.css'

import OptionBox from './option-box';

const Container = styled.div`
  border-right: 2px solid #fff;
  height: 100%;
  align-items: center;
  display: flex;
  width: 22%;
  box-sizing: border-box;
  font-size: 16px;
  padding: 0 24px;
  font-weight: 600;
  transition: all 0.3s;
  @media (max-width: 980px) {
    width: 30%;
    
  }

  .alice-carousel__dots-item {
    border: 1px solid #F1A857;
    width: 8px;
    height: 8px;
    background: none;
    border-radius: 8px;
    &.__active {
      background: #F1A857;
    }
  }
  @media (max-width: 789px) {
    width: 100%;
    border-right: 0;
    background: #DEDEDE;
    position: relative;
    border-top: 1px solid #fff;
    flex-wrap: wrap;
  }
  @media (max-width: 540px) {
    padding: 0;
  }
  .content {
    display: flex;
    width: 100%;
    align-items: center;
    min-height: 70px;
    @media (max-width: 540px) {
      justify-content: center;
    }
    span {
      flex-grow: 1;
      display: flex;
      width: 100%;
      align-items: center;
      @media (max-width: 540px) {
        width: auto;
        flex-grow: 0;
      }
    }
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 14px;
      display: inline-block;
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      vertical-align: middle;
      &.tonalidade {
        background-image: url(/images/streamline-icon-color-palette@40x40@2x.png);
      }
      &.design {
        background-image: url(/images/streamline-icon-color-palette-sample-2@40x40@2x.png);
      }
      &.categoria {
        background-image: url(/images/streamline-icon-layers-stacked-1@40x40@2x.png);
      }
    }
    .arrow {
      width: 20px;
      height: 15px;
      background: url(/images/arrow-down.png) no-repeat center;
      vertical-align: middle;
      @media (max-width: 540px) {
        margin-left: 10px;
      }
    }
  }
  .holder {
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    width: 100%;
    padding: 16px 20px;
    display: none;
    overflow: hidden;
    overflow-x: visible;
    box-sizing: border-box;
    @media (max-width: 789px) {
      position: static;
    }
    @media (max-width: 540px) {
      padding: 10px 0 0;
    }
  }
  &.open {
    min-height: 258px;
    .holder {
      display: flex;
    }
    .arrow {
      transform: rotate(180deg);
    }
  }
  @media (min-width: 789px) {
    &:hover {
      background: #fff;
      .content {
        .arrow {
          transform: rotate(180deg);
        }
      }
      .holder {
        background: #E9E9E9;
        display: flex;
      }
    }
  }
`

class Options extends Component {
  state = {
    currentIndex: 0,
    itemsInSlide: 2,
    responsive: { 0: { items: 2 } },
    fixed: false,
    isMobile: false,
    optionMobile: false,
  }

  componentDidMount = () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize);
  }

  resize = () => {
    if (document.body.clientWidth > 540) {
      this.setState({ isMobile: false });
    } else {
      this.setState({ isMobile: true });
    }
  }

  getOptions = () => {
    const {filter, options, type, category} = this.props;
    return options.map((item, index) => <OptionBox type={ type } filter={ filter } category={ category } uid={ item.uid } {...item.data} key={ index } /> )
  }

  render = () => {
    const {title, category} = this.props;
    return (
      <Container className={ this.state.optionsMobile ? 'open' : '' }>
        <div className="content" onClick={ (e) => { this.setState({'optionsMobile': !this.state.optionsMobile}) }}>
          <span>
            <i className={ `icon ${category}` }></i>
            { title }
          </span>
          <i className="arrow"></i>
        </div>
        <div className={ `holder` }>
          { this.state.isMobile && (
            <AliceCarousel 
              responsive={this.state.responsive}
              buttonsDisabled={true}
              items={this.getOptions()}/>
          )}
          { !this.state.isMobile && this.getOptions() }
        </div>
      </Container>
    )
  }
}

export default Options;
